import { CobaltPath } from 'routing/Path'

/** Shared prefix for exports / downloads React Query caches (summary table + header drawer). */
export const REPORTS_DOWNLOADS_QUERY_PREFIX = 'reportsDownloads'

export const REPORTS_SUMMARY_TABLE_QUERY_KEY = 'reportsSummaryTable'

export const REPORTS_DRAWER_QUERY_KEY = 'reportsDrawer'

export const reportsDrawerQueryKey = (
    orgId: string | undefined,
    orgGroupId: string | null | undefined
): readonly [
    string,
    string | undefined,
    string | null,
    string,
    { ordering: string; limit: number },
] =>
    [
        REPORTS_DRAWER_QUERY_KEY,
        orgId,
        orgGroupId ?? null,
        REPORTS_DOWNLOADS_QUERY_PREFIX,
        { ordering: '-created_at', limit: 15 },
    ] as const

export const reportsSummaryTableQueryKey = (
    orgId: string | undefined,
    orgGroupId: string | null | undefined,
    tablePath: CobaltPath,
    params: Record<string, unknown>
): readonly [
    string,
    string | undefined,
    string | null,
    CobaltPath,
    Record<string, unknown>,
] =>
    [
        REPORTS_SUMMARY_TABLE_QUERY_KEY,
        orgId,
        orgGroupId ?? null,
        tablePath,
        { ...params },
    ] as const
